import { FC } from "react";
import { Button, Card, Dropdown, MenuProps, Tag, Tooltip } from "../../../design-system";
import { SettingOutlined } from "@ant-design/icons";
import { Vendor } from "../../../types/VendorTypes";
import { Supplier } from "../../../types/SupplierTypes";
import styles from "./VendorCard.module.less";

interface VendorWithSpendCategory extends Vendor {
    spendCategory?: string;
}

interface VendorCardProps {
    vendor: VendorWithSpendCategory;
    supplier?: Supplier;
    noMarginBottom?: boolean;
    adminActionsMenuItems?: MenuProps["items"];
}

export const VendorCard: FC<VendorCardProps> = ({
    vendor,
    supplier,
    noMarginBottom = false,
    adminActionsMenuItems,
}) => {
    vendor.spendCategory = "Information Technology & Communications"; // HACK!

    const vendorHero = vendor.hero || supplier?.logo;
    const vendorName = vendor.name;

    const getInitials = (name: string) => {
        const words = name.split(" ");
        if (words.length === 1) {
            return name.substring(0, 2).toUpperCase();
        }
        return (words[0][0] + words[1][0]).toUpperCase();
    };

    const getColorFromString = (str: string) => {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        const hue = hash % 360;
        return `hsl(${hue}, 45%, 50%)`;
    };

    return (
        <Card
            className={`${styles.headerCard} ${styles.headerCardWithLogo} ${noMarginBottom ? styles.headerCardNoMarginBottom : ""}`}
        >
            <div className={styles.logo}>
                {vendorHero ? (
                    <img src={vendorHero} alt={vendorName} />
                ) : (
                    <div
                        className={styles.logoFallback}
                        style={{ backgroundColor: getColorFromString(vendorName) }}
                    >
                        {getInitials(vendorName)}
                    </div>
                )}
            </div>
            <div className={styles.headerContent}>
                <div className={styles.fieldRow}>
                    <div className={styles.primaryField}>
                        <div className={styles.fieldLabel}>Vendor</div>
                        <div className={styles.fieldValue}>{vendor.name}</div>
                    </div>

                    {(vendor.spendCategory || vendor.subSpendCategory) && (
                        <div className={styles.categoryField}>
                            <div className={styles.fieldLabel}>Spend Category</div>
                            <div className={styles.fieldValue}>
                                <div className={styles.categoryTags}>
                                    {vendor.spendCategory && (
                                        <Tag color="blue"><span className={styles.truncate}>{vendor.spendCategory}</span></Tag>
                                    )}
                                    {vendor.subSpendCategory && (
                                        <Tag color="blue"><span className={styles.truncate}>{vendor.subSpendCategory}</span></Tag>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}

                    <div className={styles.field}>
                        <div className={styles.fieldLabel}>Contracts</div>
                        <div className={styles.fieldValue}>{vendor.metrics?.orders || 0}</div>
                    </div>

                    {adminActionsMenuItems && adminActionsMenuItems.length > 0 && (
                        <div className={styles.actionButtons} onClick={(e) => e.stopPropagation()}>
                            <Dropdown menu={{ items: adminActionsMenuItems }} trigger={["click"]}>
                                <Tooltip title="Admin actions">
                                    <Button icon={<SettingOutlined />} />
                                </Tooltip>
                            </Dropdown>
                        </div>
                    )}
                </div>
            </div>
        </Card>
    );
};
